import { DottedLine, SideCircle, StyledTicketSeparator } from './styled';

export const MplDeutschlandTicketCardSeparator = () => {
	return (
		<StyledTicketSeparator color="neutral.0">
			<SideCircle left />
			<DottedLine color="neutral.100" />
			<SideCircle />
		</StyledTicketSeparator>
	);
};
